import React, { useState, useEffect } from 'react';
import api from './api';

export const UserTrackingLength = () => {
  const [length, setLength] = useState(0);

  useEffect(() => {
    const fetchLength = async () => {
      try {
        const response = await api.get('/clicks?limit=1');
        setLength(response.data.data.total || 0);
      } catch (error) {
        console.error('Error fetching tracking count:', error);
      }
    };
    fetchLength();
    const interval = setInterval(fetchLength, 10000); // refresh every 10s
    return () => clearInterval(interval);
  }, []);

  return <span>{length}</span>;
};
